import React from "react";
import { Button, Card, CardHeader, Plus } from "@opendate-app/setlist";

import { useMarketingSettingsContext } from "../MarketingSettingsIndexContainer";
import SendDomainRow from "./SendDomainRow";

const SendDomainsContainer = () => {
  const {
    sendDomains,
    sendDomainAdded,
  } = useMarketingSettingsContext();

  return (
    <Card header={<CardHeader title="Send domain" supportingText="Configure your send domain so marketing emails come from you." />}>
      {sendDomains.length === 0 ? (
        <Button icon={Plus} onClick={sendDomainAdded}>Add domain</Button>
      ) : (
        sendDomains.map((sendDomain) => (
          <SendDomainRow key={sendDomain.id || "new"} sendDomain={sendDomain} />
        ))
      )}
    </Card>
  );
};

export default SendDomainsContainer;
